import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import {
  sumOfGroupTotals,
  totalRowPercentageWithGrandTotals,
} from '../../../../../react-table/helpers/rowTotals';
import CarrierResdit7421PerformanceLocationReportMode from "./CarrierResdit7421PerformanceLocationReportMode";

export const getLocationTabNavigationProps = carrierData => (rowInfo, index) => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_802.id,
    mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
    requestParams: {
      carrier: rowInfo.row['cardit.postalOperator'],
      origin: rowInfo.row['cardit.originOperator'][index],
      destination: rowInfo.row['cardit.destinationOperator'][index],
      carriers: carrierData.carriers,
      isSubtotal: index === 0,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export default (data, carrierData, mode = CarrierResdit7421PerformanceLocationReportMode.percentage) => {
  const {
    MultilineColumn,
    NonZeroNumberColumn,
    MultilinePercentageGroupedColumn,
    MultilineNumberGroupedColumn,
    MultilineNumberNavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new MultilineColumn('Postal operator', 'cardit.postalOperator')
          .withTotalHeader('', 'bg-total-grey'),
        new MultilineColumn('Origin', 'cardit.originOperator')
          .withTotalHeader('', 'bg-total-grey'),
        new MultilineColumn('Destination', 'cardit.destinationOperator')
          .withTotalHeader('Total', 'bg-total-grey'),
        new MultilineNumberNavigationWithFooterColumn(
          new NonZeroNumberColumn('Total', 'cardit.total')
            .withTotalHeader(sumOfGroupTotals, 'bg-total-grey'),
          getLocationTabNavigationProps(carrierData),
        ),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_802.id,
        mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
        requestParams: {
          isTotal: carrierData.carrier === '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          isSubtotal: carrierData.carrier !== '*', // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          carrier: carrierData.carrier,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
    {
      Header: 'RESDIT',
      columns: [
        new MultilineNumberGroupedColumn('74', 'resdit.resdit74', true, 'resdit.pct74')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierResdit7421PerformanceLocationReportMode.number),
        new MultilineNumberGroupedColumn('21', 'resdit.resdit21', true, 'resdit.pct21')
          .withTotalHeader(sumOfGroupTotals, 'bg-total-grey')
          .withShow(mode === CarrierResdit7421PerformanceLocationReportMode.number),
        new MultilinePercentageGroupedColumn('% 74', 'resdit.pct74', true, 'resdit.resdit74')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['resdit.resdit74', 'cardit.total']), 'bg-total-grey')
          .withShow(mode === CarrierResdit7421PerformanceLocationReportMode.percentage),
        new MultilinePercentageGroupedColumn('% 21', 'resdit.pct21', true, 'resdit.resdit21')
          .withTotalHeader(totalRowPercentageWithGrandTotals(['resdit.resdit21', 'cardit.total']), 'bg-total-grey')
          .withShow(mode === CarrierResdit7421PerformanceLocationReportMode.percentage),
      ],
    },
  ];
};
